/**
 * Target guards for gesture start gating: resolve a gesture `EventTarget` to an
 * element and answer DOM predicates about it. Pure DOM helpers — no Solid, no
 * recognizer. Only the predicates Comandero's gestures actually consume are kept;
 * the canon also ships editability guards (`isEditableTarget` / `isEditingActive`
 * over `@/lib/dom/editable`), portable here if a future gesture needs them.
 */

function asElement(target: EventTarget | null): Element | null {
  if (target instanceof Text) {
    return target.parentElement;
  }
  return target instanceof Element ? target : null;
}

/** True if `target` (or an ancestor) matches `selector`. */
export function closestSelector(target: EventTarget | null, selector: string): boolean {
  const el = asElement(target);
  return Boolean(el?.closest(selector));
}
